export const SET_SUCCESS_REQUEST = 'SET_SUCCESS_REQUEST';
export const SET_SUCCESS_REQUEST_WITH_ID = 'SET_SUCCESS_REQUEST_WITH_ID';
export const SET_ERROR_REQUEST = 'SET_ERROR_REQUEST';
export const SET_ERROR_REQUEST_RESP = 'SET_ERROR_REQUEST_RESP';
export const CLEAR_REQUEST = 'CLEAR_REQUEST';
export const REMOVE_REQUEST_ID = 'REMOVE_REQUEST_ID';
